// Custom Designer für Laurelles - JavaScript-Logik
//
// Verantwortlich für:
//  1) Live-Preview von Text und Bild auf dem Produktbild
//  2) Auto-Setzen der versteckten Cart-Properties (fürs Backend):
//       _Design-Type   'image' oder 'text'
//       _Bildquelle    'Eigenes Bild' oder 'KI-Bild'
//       _KI-Bild-ID    24-Zeichen-ID aus unserem KI-Pool (nur bei KI-Bild)
//  3) Auto-Setzen der sichtbaren Cart-Properties (für den Kunden im Cart):
//       Wunschtext           Freitext
//       Schriftart, Farbe    ausgewählter Wert    (nur wenn Wunschtext gefüllt)
//  4) KI-Designtool — inline-Panel öffnen, Prompt an /api/ai/generate
//     senden, Vorschau zeigen, bei "Auf Produkt anzeigen" das Bild
//     als Live-Preview einsetzen und KI-Bild-ID als Cart-Property setzen.
//
// Das hochgeladene Bild selbst geht über ein eigenes File-Input (im Snippet)
// an Shopify und erscheint automatisch als Link im Cart + Customer Account.
// Der Link-Text wird vom Cart-Template angepasst auf "Link zu deinem Bild".
//
// === KI-Backend-Endpoint ===
// Liegt unter `AI_BACKEND_BASE_URL` (siehe unten). Für lokale Tests:
// http://127.0.0.1:8000. Vor Go-Live: https://api.laurelles.de o.ä.
// Wenn das KI-Backend von einer anderen Domain als der Shop kommt,
// MUSS die Origin in der Backend-Config (IMAGEN_ALLOWED_ORIGINS) freigegeben sein.

// ============================================================
// KONFIGURATION — KI-Backend
// ============================================================
// Die Backend-URL wird im Liquid-Snippet (snippets/custom-designer.liquid)
// gesetzt — siehe `window.LAURELLES_AI_BACKEND_URL`. Wir lesen sie hier mit
// Fallback. Vorteil: Asset-Cache ändert sich selten, Laura kann die URL
// im Liquid pflegen ohne JS anzufassen.
const AI_BACKEND_BASE_URL = window.LAURELLES_AI_BACKEND_URL || 'http://127.0.0.1:8000';

// Stabile Session-ID pro Browser-Session — gruppiert mehrere Generate-
// Versuche desselben Kunden, sodass Laura im Backend nachvollziehen kann,
// wie oft jemand neu generiert hat, bevor er bestellt hat (Analyse-Daten).
function getOrCreateAiSessionId() {
  try {
    let sid = sessionStorage.getItem('laurelles.aiSessionId');
    if (!sid) {
      sid = 'aisess-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      sessionStorage.setItem('laurelles.aiSessionId', sid);
    }
    return sid;
  } catch (e) {
    // sessionStorage gesperrt (Inkognito-Modus o.ä.) → fallback ohne Persistenz
    return 'aisess-tmp-' + Math.random().toString(36).slice(2, 12);
  }
}

window.addEventListener('load', function () {
  // Prüfe ob wir auf einer Produktseite mit freies-designen sind
  if (!document.querySelector('.custom-design-options')) {
    return;
  }

  console.log('Custom Designer wird geladen...');

  // UI-Elemente
  const textInput = document.getElementById('customText');
  const textOptions = document.getElementById('textOptions');
  const fontSelect = document.getElementById('fontSelect');
  const colorSelect = document.getElementById('colorSelect');
  const positionInput = document.getElementById('positionOption');
  const imageUpload = document.getElementById('imageUpload');
  const uploadedFileName = document.getElementById('uploadedFileName');

  // VERSTECKTE Cart-Properties (Backend)
  const designTypeInput = document.getElementById('designType');
  const imageSourceInput = document.getElementById('imageSource');
  const aiImageIdInput = document.getElementById('aiImageIdInput');

  // SICHTBARE Cart-Properties für Wunschtext-Flow (Bild läuft separat über das File-Input)
  const visibleFont = document.getElementById('visibleFont');
  const visibleColor = document.getElementById('visibleColor');

  // KI-Designtool-Elemente
  const aiPanelToggleBtn = document.getElementById('aiPanelToggleBtn');
  const aiDesignerPanel = document.getElementById('aiDesignerPanel');
  const aiPromptInput = document.getElementById('aiPromptInput');
  const aiCharCount = document.getElementById('aiCharCount');
  const aiHoneypot = document.getElementById('aiHoneypot');
  const aiGenerateBtn = document.getElementById('aiGenerateBtn');
  const aiLoading = document.getElementById('aiLoading');
  const aiResult = document.getElementById('aiResult');
  // Wrapper für das KI-Bild — das <img>-Element wird zur Laufzeit erzeugt
  // (siehe setAiResultImage()), damit das Liquid-Snippet kein <img src="">
  // enthält, was theme-check + IDE-Linter sonst anflaggen.
  const aiResultImageContainer = document.getElementById('aiResultImageContainer');
  const aiTryAgainBtn = document.getElementById('aiTryAgainBtn');
  const aiUsedHint = document.getElementById('aiUsedHint');
  const aiError = document.getElementById('aiError');

  /**
   * Baut die Auswahl-Kacheln in den KI-Result-Grid — eine <button>-Kachel
   * pro generierter Variante. Jede Kachel trägt image_id + preview_url als
   * data-Attribute; ein Klick wählt sie aus (selectAiImage).
   *
   * @param {Array<{image_id:string, preview_url:string}>} images
   */
  function setAiResultImages(images) {
    if (!aiResultImageContainer) return;
    aiResultImageContainer.innerHTML = '';
    delete aiResultImageContainer.dataset.selectedImageId;

    images.forEach(function (imgData, idx) {
      const choice = document.createElement('button');
      choice.type = 'button';
      choice.className = 'ai-choice';
      choice.dataset.imageId = imgData.image_id;
      choice.dataset.previewUrl = imgData.preview_url;
      choice.setAttribute('aria-label', 'Motiv ' + (idx + 1) + ' auswählen');

      const img = document.createElement('img');
      img.alt = 'KI-Motiv ' + (idx + 1);
      img.src = imgData.preview_url;
      img.width = 512;
      img.height = 512;
      choice.appendChild(img);

      const check = document.createElement('span');
      check.className = 'ai-choice-check';
      check.setAttribute('aria-hidden', 'true');
      check.textContent = '✓';
      choice.appendChild(check);

      choice.addEventListener('click', function () {
        selectAiImage(imgData.image_id, imgData.preview_url, choice);
      });

      aiResultImageContainer.appendChild(choice);
    });
  }

  function clearAiResultImages() {
    if (!aiResultImageContainer) return;
    aiResultImageContainer.innerHTML = '';
    delete aiResultImageContainer.dataset.selectedImageId;
  }

  /**
   * Kunde hat eine Kachel gewählt: Motiv aufs Produktbild legen, KI-Bild-ID
   * als Cart-Property setzen und die gewählte Kachel markieren. Klick auf die
   * andere Kachel wechselt die Auswahl. DAS ist der verbindliche Moment, in
   * dem die ID Teil der späteren Bestellung wird.
   */
  function selectAiImage(imageId, previewUrl, chosenEl) {
    if (!imageId || !previewUrl) return;

    // Cart-Property setzen
    if (aiImageIdInput) aiImageIdInput.value = imageId;
    if (aiResultImageContainer) aiResultImageContainer.dataset.selectedImageId = imageId;

    // Motiv ins Produktbild-Overlay setzen (genau wie bei Eigen-Upload).
    // KI-Motive sind immer schwarze Linienzeichnungen auf reinweißem Grund
    // (Prompt-Suffix im Backend erzwingt das) → mix-blend-mode: multiply
    // macht das weiße Quadrat auf dem Produktfoto unsichtbar, die schwarzen
    // Linien bleiben. Gilt NUR für KI-Motive — Eigen-Uploads (echte Fotos)
    // setzen den Modus wieder auf 'normal' zurück.
    if (imagePreview) {
      imagePreview.src = previewUrl;
      imagePreview.style.display = 'block';
      imagePreview.style.mixBlendMode = 'multiply';
      if (textPreview) textPreview.style.display = 'none';
    }

    // Falls vorher ein eigenes Bild hochgeladen war: zurücksetzen, damit nicht
    // beide gleichzeitig "ausgewählt" sind.
    if (imageUpload && imageUpload.value) {
      imageUpload.value = '';
      if (uploadedFileName) {
        uploadedFileName.style.display = 'none';
        uploadedFileName.textContent = '';
      }
    }

    // Nur die gewählte Kachel hervorheben
    if (aiResultImageContainer) {
      aiResultImageContainer.querySelectorAll('.ai-choice').forEach(function (c) {
        c.classList.toggle('selected', c === chosenEl);
      });
    }

    updateCartProperties();
    if (aiUsedHint) aiUsedHint.hidden = false;
  }

  // Hauptproduktbild für Live-Preview
  let mainImage =
    document.querySelector('.product__media img') ||
    document.querySelector('.product__main-photos img') ||
    document.querySelector('.product-single__photo img') ||
    document.querySelector('[data-product-featured-image]') ||
    document.querySelector('.product__image img');

  if (!mainImage) {
    console.error('Kein Produktbild gefunden!');
    return;
  }

  let imageContainer = mainImage.parentElement;
  while (imageContainer && imageContainer.tagName !== 'BODY') {
    if (
      imageContainer.classList.contains('media') ||
      imageContainer.classList.contains('product__media')
    ) {
      break;
    }
    imageContainer = imageContainer.parentElement;
  }

  if (!imageContainer) {
    imageContainer = mainImage.parentElement;
  }

  imageContainer.style.position = 'relative';

  // Preview-Container
  const previewContainer = document.createElement('div');
  previewContainer.innerHTML = `
    <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 100;">
      <div id="liveTextPreview" class="stick-text-preview" style="
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #000;
        line-height: 0;
        display: none;
      ">
        <!-- Stick-Optik v5 (Lauras Wahl 2026-07-22: Labor-Preset „Dezent").
             Inline-SVG statt div, weil Safari SVG-Filter auf HTML-Elementen
             unzuverlässig rendert — im Inline-SVG laufen sie überall stabil.
             Harte Anforderung: Fadenfarbe darf sich NICHT verfälschen —
             Rillenschatten multiplikativ (Weiß bleibt weiß), Glanz additiv
             und auf die Buchstaben geclippt (Schwarz glänzt, wird nicht grau). -->
        <svg id="liveTextPreviewSvg" xmlns="http://www.w3.org/2000/svg" width="10" height="10" style="display: block; overflow: visible;">
          <defs>
            <filter id="laurellesStickFilter" x="-15%" y="-25%" width="130%" height="150%">
              <feTurbulence type="turbulence" baseFrequency="0.008 0.55" numOctaves="2" seed="7" result="threads"/>
              <feDiffuseLighting in="threads" surfaceScale="1.1" diffuseConstant="1.05" lighting-color="#ffffff" result="diff">
                <feDistantLight azimuth="270" elevation="62"/>
              </feDiffuseLighting>
              <feComposite in="SourceGraphic" in2="diff" operator="arithmetic" k1="1" k2="0" k3="0" k4="0" result="shaded"/>
              <feSpecularLighting in="threads" surfaceScale="1.1" specularConstant="0.45" specularExponent="16" lighting-color="#ffffff" result="spec">
                <feDistantLight azimuth="270" elevation="56"/>
              </feSpecularLighting>
              <feComposite in="spec" in2="SourceAlpha" operator="in" result="specClipped"/>
              <feComposite in="shaded" in2="specClipped" operator="arithmetic" k1="0" k2="1" k3="0.6" k4="0" result="lit"/>
              <feTurbulence type="fractalNoise" baseFrequency="0.35" numOctaves="1" seed="3" result="edgeNoise"/>
              <feDisplacementMap in="lit" in2="edgeNoise" scale="1.2" xChannelSelector="R" yChannelSelector="G" result="rough"/>
              <feDropShadow dx="0" dy="1.2" stdDeviation="0.5" flood-color="#000000" flood-opacity="0.38"/>
            </filter>
          </defs>
          <text id="liveTextPreviewText" x="0" y="0" fill="currentColor" font-weight="bold" filter="url(#laurellesStickFilter)"></text>
        </svg>
      </div>
      <img id="liveImagePreview" style="
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-width: 150px;
        max-height: 150px;
        display: none;
      " />
    </div>
  `;
  imageContainer.appendChild(previewContainer.firstElementChild);

  const textPreview = document.getElementById('liveTextPreview');
  const imagePreview = document.getElementById('liveImagePreview');
  // SVG-Innenleben der Text-Vorschau (Stick-Optik): Text-Element trägt den
  // Inhalt + die Schriftgröße, das SVG wird per fitStickSvgToText() exakt
  // auf die Textbox zugeschnitten. Positionierung/Anzeige läuft weiterhin
  // über den #liveTextPreview-Wrapper (top/left/display wie bisher).
  const stickTextEl = document.getElementById('liveTextPreviewText');
  const stickTextSvg = document.getElementById('liveTextPreviewSvg');

  // SVG-Viewport exakt auf die Textbox legen (inkl. Baseline-Versatz), damit
  // die translate(-50%,-50%)-Zentrierung des Wrappers wie beim alten div
  // greift. overflow:visible lässt den Filter-Schatten über den Rand zeichnen.
  function fitStickSvgToText() {
    if (!stickTextSvg || !stickTextEl) return;
    try {
      const bb = stickTextEl.getBBox();
      if (bb.width > 0 && bb.height > 0) {
        stickTextSvg.setAttribute('viewBox', bb.x + ' ' + bb.y + ' ' + bb.width + ' ' + bb.height);
        stickTextSvg.setAttribute('width', Math.round(bb.width));
        stickTextSvg.setAttribute('height', Math.round(bb.height));
      }
    } catch (e) {
      // getBBox wirft, solange das SVG nicht gerendert ist — nächster
      // updatePreviewSize-Aufruf holt das nach.
    }
  }

  // ============================================================
  // Customizer-Konfiguration (Anker, T-Shirt-Breite) — DIREKT aus Shopify
  // ============================================================
  //
  // Lauras Entscheidung 2026-07-14: Die Positions-Kalibrierung lebt komplett
  // in Shopify (Produkt-Metafelder, von custom-designer.liquid als
  // window.LAURELLES_CUSTOMIZER_CONFIG gerendert) — KEIN Backend-Call mehr.
  // Das Backend bekommt weiterhin nur Position + Größe über die Cart-Properties.
  // Produkt ohne Metafelder → Hardcode-Defaults (Anker, Snap-Werte, 48cm).
  let backendConfig = null;
  let tshirtWidthCm = 48; // Default für Pixel↔cm-Umrechnung

  function fetchCustomizerConfig() {
    const cfg = window.LAURELLES_CUSTOMIZER_CONFIG;
    if (!cfg || !cfg.anchors) {
      console.log('[Laurelles Customizer] Keine Metafeld-Kalibrierung für dieses Produkt — Hardcode-Defaults aktiv.');
      return;
    }
    backendConfig = cfg;
    applyBackendConfig(cfg);
  }

  function applyBackendConfig(cfg) {
    if (cfg.tshirt_width_cm && cfg.tshirt_width_cm > 0) {
      tshirtWidthCm = cfg.tshirt_width_cm;
    }
    if (cfg.snap_points && window.__laurellesSizeSteps) {
      try {
        const labels = ['small', 'medium', 'large'];
        ['image', 'text'].forEach(function (type) {
          if (!Array.isArray(cfg.snap_points[type])) return;
          cfg.snap_points[type].forEach(function (sp, idx) {
            const key = labels[idx];
            if (!key) return;
            window.__laurellesSizeSteps[type][key] = {
              widthMm: Math.round(sp.width_cm * 10),
              label: 'ca. ' + sp.range_label + (type === 'text' ? ' hoch' : ' breit'),
            };
          });
        });
        const activeBtn = document.querySelector('.size-step-btn.active');
        if (activeBtn) {
          const cfg2 = window.__laurellesSizeSteps;
          const step = activeBtn.dataset.sizeStep;
          const stepCfg = cfg2[cfg2.currentType][step];
          const widthInput = document.getElementById('widthMmInput');
          const rangeLabel = document.getElementById('sizeStepRangeLabel');
          if (widthInput) widthInput.value = stepCfg.widthMm;
          if (rangeLabel) rangeLabel.textContent = stepCfg.label;
        }
      } catch (e) {
        console.warn('[Laurelles Customizer] Snap-Punkte konnten nicht angewendet werden:', e);
      }
    }
    // Anker sofort auf die Preview anwenden (passend zur aktuell gewählten
    // Position) — sonst startet die Vorschau auf den Hardcode-Defaults (50/50),
    // bis der Kunde zum ersten Mal einen Positions-Button klickt.
    if (cfg.anchors && cfg.anchors.center && cfg.anchors.left) {
      const posEl = document.getElementById('positionOption');
      const a = (posEl && posEl.value === 'Vorne links') ? cfg.anchors.left : cfg.anchors.center;
      const topPct = (a.y_pct * 100) + '%';
      const leftPct = (a.x_pct * 100) + '%';
      [textPreview, imagePreview].forEach(function (el) {
        if (el) { el.style.top = topPct; el.style.left = leftPct; }
      });
    }

    const widthInput = document.getElementById('widthMmInput');
    if (widthInput) updatePreviewSize(parseFloat(widthInput.value));
    console.log('[Laurelles Customizer] Metafeld-Kalibrierung angewendet.');
  }

  // ============================================================
  // Live-Preview-Größe in Pixel berechnen aus widthMm
  // ============================================================
  // Berechnung: pixel_per_cm = renderedImageWidthPx / tshirtWidthCm
  //             previewPx     = (widthMm/10) * pixel_per_cm
  //
  // Wichtig: CSS mit setProperty(..., '', 'important') überschreiben, damit
  // hardcoded Inline-Styles (max-width: 150px etc.) aus dem dynamisch
  // erzeugten Preview-Container nicht gewinnen.
  function updatePreviewSize(widthMm) {
    if (!widthMm || !mainImage) {
      console.log('[Laurelles Customizer] updatePreviewSize abgebrochen — kein widthMm oder kein mainImage', { widthMm: widthMm, hasMainImage: !!mainImage });
      return;
    }
    const imageRenderedWidth = mainImage.clientWidth || mainImage.offsetWidth || mainImage.getBoundingClientRect().width;
    if (!imageRenderedWidth || imageRenderedWidth < 50) {
      console.log('[Laurelles Customizer] updatePreviewSize wartet auf Bild-Rendering (clientWidth=' + imageRenderedWidth + ')');
      // Retry nach kurzem Delay — Bild ist evtl. noch im Lazy-Load
      setTimeout(function () { updatePreviewSize(widthMm); }, 200);
      return;
    }

    const pixelPerCm = imageRenderedWidth / tshirtWidthCm;
    const widthCm = widthMm / 10;
    const previewWidthPx = Math.round(widthCm * pixelPerCm);

    console.log('[Laurelles Customizer] Preview-Größe: ' + widthMm + 'mm = ' + widthCm + 'cm = ' + previewWidthPx + 'px (Bild: ' + imageRenderedWidth + 'px / T-Shirt: ' + tshirtWidthCm + 'cm)');

    if (imagePreview) {
      imagePreview.style.setProperty('max-width', previewWidthPx + 'px', 'important');
      imagePreview.style.setProperty('width', previewWidthPx + 'px', 'important');
      imagePreview.style.setProperty('max-height', 'none', 'important');
      imagePreview.style.setProperty('height', 'auto', 'important');
    }
    if (textPreview && textPreview.style.display !== 'none' && stickTextEl && stickTextEl.textContent) {
      // Einheitliche Größenlogik (Laura 2026-07-14): widthMm ist die BREITE —
      // auch beim Schriftzug. Wir setzen eine Probe-Schriftgröße, messen die
      // gerenderte Textbreite und skalieren die Schriftgröße so, dass der
      // Text exakt previewWidthPx breit wird (unabhängig von Textlänge/Font).
      // Seit Stick-Optik v5 per SVG-APIs (getComputedTextLength statt offsetWidth).
      const probePx = 100;
      stickTextEl.setAttribute('font-size', probePx);
      let renderedTextWidth = 0;
      try {
        renderedTextWidth = stickTextEl.getComputedTextLength();
      } catch (e) {
        // noch nicht gerendert — Retry kommt über die bestehenden Aufrufer
      }
      if (renderedTextWidth > 0) {
        const fittedPx = Math.max(6, probePx * previewWidthPx / renderedTextWidth);
        stickTextEl.setAttribute('font-size', fittedPx);
      }
      fitStickSvgToText();
    }
  }

  // ============================================================
  // Globale Exports — damit das Snippet-Inline-Script (selectSizeStep, selectPosition)
  // direkt Zugriff hat, OHNE auf CustomEvents zu warten. Sicherer als nur Events.
  // ============================================================
  window.laurellesUpdatePreviewSize = updatePreviewSize;

  document.addEventListener('laurelles:sizeStepChanged', function (evt) {
    if (evt && evt.detail && evt.detail.widthMm) {
      updatePreviewSize(evt.detail.widthMm);
    }
  });

  // Initial: Preview-Größe einmal setzen (verzögert, bis Bild gerendert)
  setTimeout(function () {
    const widthInput = document.getElementById('widthMmInput');
    if (widthInput) updatePreviewSize(parseFloat(widthInput.value));
  }, 500);

  fetchCustomizerConfig();


  // ============================================================
  // Hauptlogik: alle Cart-Properties basierend auf User-Auswahl setzen
  // ============================================================
  // Prioritätsreihenfolge bei mehrfacher Auswahl:
  //   1. Eigenes hochgeladenes Bild   → 'image' / 'Eigenes Bild'
  //   2. KI-generiertes Bild          → 'image' / 'KI-Bild'  + KI-Bild-ID
  //   3. Wunschtext                   → 'text'
  //   (sonst: leer, Mapper überspringt das Line-Item)
  function updateCartProperties() {
    const text = (textInput?.value || '').trim();
    const hasImage = imageUpload?.files && imageUpload.files.length > 0;
    const hasAiImage = !!(aiImageIdInput?.value || '').trim();

    if (hasImage) {
      // Eigenes Bild hat höchste Priorität
      designTypeInput.value = 'image';
      imageSourceInput.value = 'Eigenes Bild';
      // KI-Bild-ID leeren, falls vorher gesetzt — Kunde hat sich entschieden
      if (aiImageIdInput) aiImageIdInput.value = '';
    } else if (hasAiImage) {
      // KI-Bild übernommen
      designTypeInput.value = 'image';
      imageSourceInput.value = 'KI-Bild';
      // aiImageIdInput.value bleibt bestehen
    } else if (text) {
      designTypeInput.value = 'text';
      imageSourceInput.value = '';
    } else {
      designTypeInput.value = '';
      imageSourceInput.value = '';
    }

    // Sichtbare Properties: Schriftart + Farbe nur wenn Wunschtext eingegeben
    if (text) {
      visibleFont.value = fontSelect?.value || '';
      visibleColor.value = colorSelect?.value || '';
    } else {
      visibleFont.value = '';
      visibleColor.value = '';
    }
  }

  // ============================================================
  // Text-Input Event
  // ============================================================
  if (textInput) {
    textInput.addEventListener('input', function () {
      const text = this.value.trim();

      // UI: Schriftart/Farbe-Optionen ein-/ausblenden
      if (text) {
        if (textOptions) textOptions.style.display = 'block';
        if (textPreview) {
          textPreview.style.display = 'block';
          if (stickTextEl) stickTextEl.textContent = text;
          imagePreview.style.display = 'none';
        }
        // Größen-Slider auf Schriftzug-Werte umschalten (kleinere Snap-Punkte)
        if (typeof window.__laurellesSwitchSizeStepType === 'function') {
          window.__laurellesSwitchSizeStepType('text');
        }
      } else {
        if (textOptions) textOptions.style.display = 'none';
        if (textPreview) textPreview.style.display = 'none';
        // Wieder zurück auf Bild-Snap-Werte
        if (typeof window.__laurellesSwitchSizeStepType === 'function') {
          window.__laurellesSwitchSizeStepType('image');
        }
      }

      // Schriftgröße an die Textbreite anpassen — bei jedem Tastendruck,
      // weil längerer Text bei gleicher Zielbreite kleinere Schrift braucht.
      const widthInputEl = document.getElementById('widthMmInput');
      if (widthInputEl) updatePreviewSize(parseFloat(widthInputEl.value));

      updateCartProperties();
    });
  }

  // ============================================================
  // Schriftart ändern
  // ============================================================
  if (fontSelect) {
    fontSelect.addEventListener('change', function () {
      if (textPreview) {
        textPreview.style.fontFamily = this.value;
        // Andere Schriftart = andere Laufweite → Breite neu einpassen
        const widthInputEl = document.getElementById('widthMmInput');
        if (widthInputEl) updatePreviewSize(parseFloat(widthInputEl.value));
      }
      updateCartProperties();
    });
  }

  // ============================================================
  // Schriftfarbe ändern
  // ============================================================
  if (colorSelect) {
    colorSelect.addEventListener('change', function () {
      // Die Farbwerte stehen als data-hex an den <option>s im Snippet
      // (snippets/custom-designer.liquid) — dort liegt die Palette an EINER
      // Stelle, zusammen mit den Brandsky-Garnnamen. Früher stand hier eine
      // zweite, handgepflegte Liste; die lief zwangsläufig auseinander.
      // Fallback Schwarz, falls ein <option> mal kein data-hex trägt.
      const gewaehlt = this.selectedOptions && this.selectedOptions[0];
      const hex = (gewaehlt && gewaehlt.dataset.hex) || '#000000';
      if (textPreview) {
        // Stick-Optik v5: das SVG-<text> hat fill="currentColor" und erbt
        // die Fadenfarbe direkt von hier — der Licht-Filter lässt sie
        // unangetastet (Lauras harte Anforderung).
        textPreview.style.color = hex;
      }
      updateCartProperties();
    });
  }

  // ============================================================
  // Position ändern (Live-Preview)
  // ============================================================
  if (positionInput) {
    positionInput.addEventListener('change', function () {
      // Position-Map: Wenn Backend-Konfig kalibriert ist, nimm die produkt-
      // spezifischen Anker. Sonst fallback auf hardcoded Defaults.
      //
      // SPIEGELUNG: „Vorne links" = linke Brust AM TRÄGER = rechte Bildseite
      // (deshalb left: 70% im Default).
      let positions;
      if (backendConfig && backendConfig.anchors) {
        const a = backendConfig.anchors;
        positions = {
          'Vorne Mitte': {
            top:  (a.center.y_pct * 100) + '%',
            left: (a.center.x_pct * 100) + '%',
          },
          'Vorne links': {
            top:  (a.left.y_pct * 100) + '%',
            left: (a.left.x_pct * 100) + '%',
          },
        };
      } else {
        positions = {
          'Vorne Mitte': { top: '50%', left: '50%' },
          'Vorne links': { top: '30%', left: '70%' },
        };
      }

      const pos = positions[this.value] || positions['Vorne Mitte'];

      if (textPreview && textPreview.style.display !== 'none') {
        textPreview.style.top = pos.top;
        textPreview.style.left = pos.left;
      }
      if (imagePreview && imagePreview.style.display !== 'none') {
        imagePreview.style.top = pos.top;
        imagePreview.style.left = pos.left;
      }
    });
  }

  // ============================================================
  // Bild-Upload Event
  // ============================================================
  if (imageUpload) {
    imageUpload.addEventListener('change', function (e) {
      const file = e.target.files[0];

      if (!file) {
        if (uploadedFileName) {
          uploadedFileName.style.display = 'none';
          uploadedFileName.textContent = '';
        }
        if (imagePreview) imagePreview.style.display = 'none';
        updateCartProperties();
        return;
      }

      if (uploadedFileName) {
        uploadedFileName.style.display = 'block';
        uploadedFileName.textContent = '✓ ' + file.name;
      }

      const reader = new FileReader();
      reader.onload = function (event) {
        if (imagePreview) {
          imagePreview.src = event.target.result;
          imagePreview.style.display = 'block';
          // Eigen-Upload = echtes Foto → normal anzeigen (kein multiply,
          // sonst würden helle Bildteile auf dem Produkt durchsichtig)
          imagePreview.style.mixBlendMode = 'normal';
          if (textPreview) textPreview.style.display = 'none';
        }
      };
      reader.readAsDataURL(file);

      // Wenn der Kunde ein eigenes Bild hochlädt UND vorher ein KI-Bild
      // ausgewählt hatte: KI-Auswahl zurücksetzen, damit kein Konflikt
      // entsteht. updateCartProperties() leert aiImageIdInput dann ebenfalls.
      if (aiImageIdInput?.value && aiUsedHint) {
        aiUsedHint.hidden = true;
      }

      updateCartProperties();
    });
  }

  // ============================================================
  // KI-Designtool — Inline-Panel + Generate-Workflow
  // ============================================================
  if (aiPanelToggleBtn && aiDesignerPanel) {
    // Panel auf-/zuklappen — andere Buttons rutschen natürlich nach unten,
    // weil das Panel im normalen Document-Flow steht (kein absolute Pos.)
    aiPanelToggleBtn.addEventListener('click', function () {
      const isOpen = !aiDesignerPanel.hasAttribute('hidden');
      if (isOpen) {
        aiDesignerPanel.setAttribute('hidden', '');
        aiPanelToggleBtn.setAttribute('aria-expanded', 'false');
      } else {
        aiDesignerPanel.removeAttribute('hidden');
        aiPanelToggleBtn.setAttribute('aria-expanded', 'true');
        // Fokus auf das Eingabefeld, damit der Kunde direkt tippen kann
        setTimeout(() => aiPromptInput?.focus(), 50);
      }
    });
  }

  // Zeichen-Zähler live aktualisieren
  if (aiPromptInput && aiCharCount) {
    aiPromptInput.addEventListener('input', function () {
      aiCharCount.textContent = String(aiPromptInput.value.length);
    });
  }

  // Hilfsfunktionen für UI-Zustand
  function showAiLoading() {
    if (aiLoading) aiLoading.hidden = false;
    if (aiResult) aiResult.hidden = true;
    if (aiError) aiError.hidden = true;
    if (aiGenerateBtn) {
      aiGenerateBtn.disabled = true;
      aiGenerateBtn.textContent = 'Wird erstellt…';
    }
  }
  function hideAiLoading() {
    if (aiLoading) aiLoading.hidden = true;
    if (aiGenerateBtn) {
      aiGenerateBtn.disabled = false;
      // Beim ersten Generierungsversuch: 'Motiv erstellen'.
      // Nach mindestens einem Versuch: 'Neues Motiv erstellen'.
      const hasAttempt = !!aiImageIdInput?.value
        || !!(aiResultImageContainer && aiResultImageContainer.children.length);
      aiGenerateBtn.textContent = hasAttempt ? 'Neue Motive erstellen' : 'Motiv erstellen';
    }
  }
  function showAiError(message) {
    hideAiLoading();
    if (aiResult) aiResult.hidden = true;
    if (aiError) {
      aiError.hidden = false;
      aiError.textContent = message;
    }
  }
  function showAiResult(images) {
    hideAiLoading();
    if (aiError) aiError.hidden = true;
    setAiResultImages(images);
    if (aiResult) aiResult.hidden = false;
    // Neue Runde → Hinweis "wird verknüpft" erst wieder zeigen, wenn der
    // Kunde eine der neuen Kacheln anklickt.
    if (aiUsedHint) aiUsedHint.hidden = true;
  }

  // Generate-Button — POST an /api/ai/generate
  if (aiGenerateBtn) {
    aiGenerateBtn.addEventListener('click', async function () {
      const prompt = (aiPromptInput?.value || '').trim();
      if (prompt.length < 2) {
        showAiError('Bitte gib mindestens 2 Zeichen ein.');
        aiPromptInput?.focus();
        return;
      }
      if (prompt.length > 500) {
        showAiError('Bitte halte den Prompt unter 500 Zeichen.');
        return;
      }

      showAiLoading();

      try {
        const response = await fetch(AI_BACKEND_BASE_URL + '/api/ai/generate', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({
            prompt: prompt,
            session_id: getOrCreateAiSessionId(),
            website: aiHoneypot?.value || '', // Honeypot — sollte immer leer sein
          }),
        });

        if (!response.ok) {
          const errBody = await response.json().catch(() => ({}));
          if (response.status === 429) {
            showAiError(errBody.message || 'Du hast die maximale Anzahl Versuche erreicht. Bitte später erneut versuchen.');
          } else if (response.status === 422) {
            showAiError(errBody.message || 'Bitte überprüfe deine Eingabe.');
          } else if (response.status === 403) {
            showAiError('Diese Anfrage ist nicht erlaubt. Bitte lade die Seite neu.');
          } else {
            showAiError('Ein Fehler ist aufgetreten. Bitte versuche es in einigen Sekunden erneut.');
          }
          return;
        }

        const data = await response.json();

        // Neues Format: { images: [{image_id, preview_url}, ...] }.
        // Fallback aufs alte Einzel-Format, falls das Backend mal nur
        // image_id/preview_url liefert (Abwärtskompatibilität).
        let images = Array.isArray(data.images) ? data.images : [];
        if (!images.length && data.image_id && data.preview_url) {
          images = [{ image_id: data.image_id, preview_url: data.preview_url }];
        }
        images = images.filter(function (i) { return i && i.image_id && i.preview_url; });

        if (!images.length) {
          showAiError('Unerwartete Antwort vom Server. Bitte erneut versuchen.');
          return;
        }

        // Varianten als Auswahl-Kacheln anzeigen. Erst wenn der Kunde eine
        // Kachel anklickt, landet deren ID im Cart-Property (_KI-Bild-ID).
        showAiResult(images);

      } catch (err) {
        console.error('KI-Generate-Fehler:', err);
        showAiError('Verbindung zum KI-Server fehlgeschlagen. Bitte Internet prüfen.');
      }
    });
  }

  // "Anderes Motiv versuchen" — Reset der Anzeige, Kunde kann neuen Prompt
  // eintippen und neu generieren. Eine ggf. schon getroffene Auswahl bleibt
  // als Cart-Property bestehen, bis der Kunde eine neue Kachel anklickt.
  if (aiTryAgainBtn) {
    aiTryAgainBtn.addEventListener('click', function () {
      if (aiResult) aiResult.hidden = true;
      if (aiError) aiError.hidden = true;
      clearAiResultImages();
      aiPromptInput?.focus();
      aiPromptInput?.select();
    });
  }

  // Hinweis: Die Auswahl eines Motivs passiert jetzt durch Klick auf eine der
  // Bild-Kacheln (selectAiImage), nicht mehr über einen separaten Button.

  // Initial: alle Properties auf den Anfangszustand setzen
  updateCartProperties();

  console.log('Custom Designer erfolgreich initialisiert');
});
